import Box from "@mui/material/Box";
import { useEffect } from "react";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { updateSubroute } from "../../../../store/route_slice";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
const SuperSetPage = ({ id }: { id: string }) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("superset_token");

  useEffect(() => {
    const timer = setTimeout(
      () => {
        dispatch(updateSubroute({ parent: "reports", subRoute: "" }));
      },
      1000 * 60 * 60 * 6,
    );
    if (id) {
      dispatch(updateSubroute({ parent: "reports", subRoute: id }));
    }

    console.log("token", token);
    if (token) {
      const embed = async () => {
        try {
          await embedDashboard({
            id: id, // given by the Superset embedding UI
            supersetDomain: "https://dashboard.varahaag.com",
            mountPoint: document.getElementById("reports") as HTMLElement, // any html element that can contain an iframe
            fetchGuestToken: async () => token,
            dashboardUiConfig: {
              // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
              hideTitle: true,

              filters: {
                expanded: true,
              },
            },
          });
        } catch (err) {
          console.error("Superset emedbing error", err);
        }
      };
      if (document.getElementById("reports")) {
        embed();
        const iframeElement = document.getElementsByTagName("iframe")[0];
        iframeElement.height = "80%";
        iframeElement.width = "100%";
        iframeElement.style.border = "none";
      }
    }
    if (
      dayjs().diff(
        dayjs(localStorage.getItem("superset_token_expiry")),
        "hour",
      ) >= 6
    ) {
      dispatch(updateSubroute({ parent: "reports", subRoute: "" }));
    }
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return <Box id="reports" sx={{ height: "1000px" }}></Box>;
};
export default SuperSetPage;
